// import React, { useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom";
// import axios from "axios";
// // import { useUser } from "../../pages/UserContext";
// import "./Navbar.css";
// import Logo from "../../assets/Logo.png";

// const Navbar = ({ sidebarOpen, toggleSidebar }) => {
//   const [profileDropdownOpen, setProfileDropdownOpen] = useState(false);
//   const [projects, setProjects] = useState([]);
//   const [selectedProject, setSelectedProject] = useState("");
//   const navigate = useNavigate();
//   // const { username, setUsername } = useUser(); // Access username and setUsername from context
//   const username = sessionStorage.getItem('username');

//   const toggleProfileDropdown = () => {
//     setProfileDropdownOpen(!profileDropdownOpen);
//   };

//   const handleClickOutside = (event) => {
//     if (!event.target.closest("#profile-dropdown") && !event.target.closest("#profile-dropdown-menu")) {
//       setProfileDropdownOpen(false);
//     }
//   };

//   useEffect(() => {
//     if (profileDropdownOpen) {
//       document.addEventListener("click", handleClickOutside);
//     } else {
//       document.removeEventListener("click", handleClickOutside);
//     }

//     return () => {
//       document.removeEventListener("click", handleClickOutside);
//     };
//   }, [profileDropdownOpen]);

//   // Fetch projects from the backend
//   useEffect(() => {
//     const fetchProjects = async () => {
//       try {
//         const response = await axios.get("https://redoms-backend-dev.m-devsecops.com/get_project_names");
//         const formattedProjects = response.data.map((project) => ({
//           id: project.project_id,
//           name: project.project_name,
//         }));
//         setProjects(formattedProjects);

//         // Initialize selected project from localStorage
//         const storedProjectId = localStorage.getItem("selectedProject");
//         const storedProjectName = localStorage.getItem("selectedProjectName");

//         if (storedProjectId && storedProjectName) {
//           setSelectedProject(storedProjectName);
//         } else if (formattedProjects.length > 0) {
//           setSelectedProject(formattedProjects[0].name);
//           localStorage.setItem("selectedProject", formattedProjects[0].id);
//           localStorage.setItem("selectedProjectName", formattedProjects[0].name);
//         }
//       } catch (error) {
//         console.error("Error fetching projects:", error);
//       }
//     };

//     fetchProjects();
//   }, []);

//   // Handle project change
//   const handleProjectChange = (event) => {
//     const selectedProjectName = event.target.value;
//     const selectedProjectData = projects.find(project => project.name === selectedProjectName);

//     if (selectedProjectData) {
//       setSelectedProject(selectedProjectName);
//       localStorage.setItem("selectedProject", selectedProjectData.id);
//       localStorage.setItem("selectedProjectName", selectedProjectData.name);

//       // Refresh the page to load the new project
//       window.location.reload();
//     }
//   };

//   // Handle logout
//   const handleLogout = () => {
//     // setUsername(""); // Clear username in context
//     const logoutUrl = `http://localhost:8080/realms/ReDoms/protocol/openid-connect/logout?post_logout_redirect_uri=http://localhost:3000&client_id=Redoms`; 
//     window.location.href = logoutUrl;
//   };

//   return (
//     <div
//       id="Navbar"
//       className="navbar-container"
//       style={{
//         marginLeft: sidebarOpen ? 300 : 60,
//         transition: "margin-left 0.1s",
//       }}
//     >
//       <div className="navbar-left">
//         <img id="Logo" className="logo" width="120" src={Logo} alt="Logo" />
//       </div>
//       <div className="navbar-right">
//         <div>
//           <select
//             value={selectedProject}
//             onChange={handleProjectChange}
//             className="project-dropdown"
//           >
//             <option value="">Select Project</option>
//             {projects.map((project) => (
//               <option key={project.id} value={project.name}>
//                 {project.name}
//               </option>
//             ))}
//           </select>
//         </div>
//         <div className="navbar-right">
//           <div className="profile-container">
//             <i
//               id="profile-dropdown"
//               className="profile-icon fa-solid fa-user"
//               onClick={toggleProfileDropdown}
//             ></i>
//             {profileDropdownOpen && (
//               <div
//                 className="profile-dropdown"
//                 id="profile-dropdown-menu"
//               >
//                 <div className="profile-info">
//                   <p className="profile-username">{username}</p> {/* Display username from context */}
//                 </div>
//                 <button
//                   className="logout-button"
//                   onClick={handleLogout}
//                 >
//                   Logout
//                 </button>
//               </div>
//             )}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Navbar;


// import React, { useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom";
// import { signOut } from "firebase/auth";
// import { auth } from "../../firebase"; // Import your Firebase auth instance
// import axios from "axios";
// import "./Navbar.css";
// import Logo from "../../assets/Logo.png";

// const Navbar = ({ sidebarOpen, toggleSidebar }) => {
//   const [profileDropdownOpen, setProfileDropdownOpen] = useState(false);
//   const [projects, setProjects] = useState([]);
//   const [selectedProject, setSelectedProject] = useState("");
//   const navigate = useNavigate();
//   const username = sessionStorage.getItem("username"); // Get username from sessionStorage

//   const toggleProfileDropdown = () => {
//     setProfileDropdownOpen(!profileDropdownOpen);
//   };

//   const handleClickOutside = (event) => {
//     if (!event.target.closest("#profile-dropdown") && !event.target.closest("#profile-dropdown-menu")) {
//       setProfileDropdownOpen(false);
//     }
//   };

//   useEffect(() => {
//     // Check if username exists, if not, log out
//     if (!username) {
//       handleLogout();
//       return;
//     }

//     if (profileDropdownOpen) {
//       document.addEventListener("click", handleClickOutside);
//     } else {
//       document.removeEventListener("click", handleClickOutside);
//     }

//     return () => {
//       document.removeEventListener("click", handleClickOutside);
//     };
//   }, [profileDropdownOpen, username]);

//   // Fetch projects from the backend
//   useEffect(() => {
//     const fetchProjects = async () => {
//       try {
//         const response = await axios.get("https://redoms-backend-dev.m-devsecops.com/get_project_names");
//         const formattedProjects = response.data.map((project) => ({
//           id: project.project_id,
//           name: project.project_name,
//         }));
//         setProjects(formattedProjects);

//         // Initialize selected project from localStorage
//         const storedProjectId = localStorage.getItem("selectedProject");
//         const storedProjectName = localStorage.getItem("selectedProjectName");

//         if (storedProjectId && storedProjectName) {
//           setSelectedProject(storedProjectName);
//         } else if (formattedProjects.length > 0) {
//           setSelectedProject(formattedProjects[0].name);
//           localStorage.setItem("selectedProject", formattedProjects[0].id);
//           localStorage.setItem("selectedProjectName", formattedProjects[0].name);
//         }
//       } catch (error) {
//         console.error("Error fetching projects:", error);
//       }
//     };

//     fetchProjects();
//   }, []);

//   // Handle project change
//   const handleProjectChange = (event) => {
//     const selectedProjectName = event.target.value;
//     const selectedProjectData = projects.find((project) => project.name === selectedProjectName);

//     if (selectedProjectData) {
//       setSelectedProject(selectedProjectName);
//       localStorage.setItem("selectedProject", selectedProjectData.id);
//       localStorage.setItem("selectedProjectName", selectedProjectData.name);

//       // Refresh the page to load the new project
//       window.location.reload();
//     }
//   };

//   // Handle logout with Firebase
//   const handleLogout = async () => {
//     try {
//       await signOut(auth); // Sign out from Firebase
//       sessionStorage.removeItem("username"); // Clear username from sessionStorage
//       navigate("/login", { replace: true }); // Redirect to login page and replace history
//     } catch (error) {
//       console.error("Error logging out:", error);
//     }
//   };

//   return (
//     <div
//       id="Navbar"
//       className="navbar-container"
//       style={{
//         marginLeft: sidebarOpen ? 300 : 60,
//         transition: "margin-left 0.1s",
//       }}
//     >
//       <div className="navbar-left">
//         <img id="Logo" className="logo" width="120" src={Logo} alt="Logo" />
//       </div>
//       <div className="navbar-right">
//         <div>
//           <select
//             value={selectedProject}
//             onChange={handleProjectChange}
//             className="project-dropdown"
//           >
//             <option value="">Select Project</option>
//             {projects.map((project) => (
//               <option key={project.id} value={project.name}>
//                 {project.name}
//               </option>
//             ))}
//           </select>
//         </div>
//         <div className="navbar-right">
//           <div className="profile-container">
//             <i
//               id="profile-dropdown"
//               className="profile-icon fa-solid fa-user"
//               onClick={toggleProfileDropdown}
//             ></i>
//             {profileDropdownOpen && (
//               <div className="profile-dropdown" id="profile-dropdown-menu">
//                 <div className="profile-info">
//                   <p className="profile-username">{username}</p> {/* Display username from sessionStorage */}
//                 </div>
//                 <button className="logout-button" onClick={handleLogout}>
//                   Logout
//                 </button>
//               </div>
//             )}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Navbar;


import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { signOut } from "firebase/auth";
import { auth } from "../../firebase";
import axios from "axios";
import Logo from "../../assets/Logo.png";

const Navbar = ({ sidebarOpen, toggleSidebar }) => {
  const [profileDropdownOpen, setProfileDropdownOpen] = useState(false);
  const [allProjects, setAllProjects] = useState([]);        // All from backend
  const [allowedProjects, setAllowedProjects] = useState([]); // Filtered for user
  const [selectedProject, setSelectedProject] = useState("");
  
  const navigate = useNavigate();
  const username = sessionStorage.getItem("username")?.toLowerCase(); // normalize
  const baseURL = process.env.REACT_APP_API_BASE_URL;

  // === CONFIG: Define which projects each user can access ===
  const USER_PROJECT_ACCESS = {
    "ul.susten": ["NHPC_300MW", "Swaraj 40 MW, Punjab"],
    "waaree.susten": ["NHPC_300MW", "Swaraj 40 MW, Punjab"],
    "rayzon.susten": ["NHPC_300MW"],
  };

  // Fallback: users not in the list get ALL projects
  const getAllowedProjectNames = () => {
    return USER_PROJECT_ACCESS[username] || null; // null means "all projects"
  };

  const toggleProfileDropdown = () => {
    setProfileDropdownOpen(!profileDropdownOpen);
  };

  const handleClickOutside = (event) => {
    if (
      !event.target.closest("#profile-dropdown") &&
      !event.target.closest("#profile-dropdown-menu")
    ) {
      setProfileDropdownOpen(false);
    }
  };

  useEffect(() => {
    if (!username) {
      handleLogout();
      return;
    }

    if (profileDropdownOpen) {
      document.addEventListener("click", handleClickOutside);
    } else {
      document.removeEventListener("click", handleClickOutside);
    }

    return () => document.removeEventListener("click", handleClickOutside);
  }, [profileDropdownOpen, username]);

  // Fetch all projects from backend
  useEffect(() => {
    const fetchProjects = async () => {
      try {
        const response = await axios.get(`${baseURL}get_project_names`);
        const projectsFromApi = response.data.map((project) => ({
          id: project.project_id,
          name: project.project_name,
        }));

        setAllProjects(projectsFromApi);

        // Determine allowed project names for this user
        const allowedNames = getAllowedProjectNames();

        let filteredProjects;
        if (allowedNames === null) {
          // User not restricted → can see all
          filteredProjects = projectsFromApi;
        } else {
          // Filter only allowed ones
          filteredProjects = projectsFromApi.filter((p) =>
            allowedNames.includes(p.name)
          );
        }

        setAllowedProjects(filteredProjects);

        // Restore previously selected project if still allowed
        const storedName = localStorage.getItem("selectedProjectName");
        const storedId = localStorage.getItem("selectedProject");

        const validPrevious = filteredProjects.find(
          (p) => p.name === storedName || p.id === storedId
        );

        if (validPrevious) {
          setSelectedProject(validPrevious.name);
        } else if (filteredProjects.length > 0) {
          // Default to first allowed project
          const first = filteredProjects[0];
          setSelectedProject(first.name);
          localStorage.setItem("selectedProject", first.id);
          localStorage.setItem("selectedProjectName", first.name);
        }
      } catch (error) {
        console.error("Error fetching projects:", error);
        setAllowedProjects([]);
      }
    };

    fetchProjects();
  }, [baseURL, username]);

  const handleProjectChange = (e) => {
    const selectedName = e.target.value;
    if (!selectedName) return;

    const project = allowedProjects.find((p) => p.name === selectedName);
    if (project) {
      setSelectedProject(selectedName);
      localStorage.setItem("selectedProject", project.id);
      localStorage.setItem("selectedProjectName", project.name);
      window.location.reload(); // Or use context for better UX
    }
  };

  const handleLogout = async () => {
    try {
      await signOut(auth);
      sessionStorage.removeItem("username");
      localStorage.removeItem("selectedProject");
      localStorage.removeItem("selectedProjectName");
      navigate("/login", { replace: true });
    } catch (error) {
      console.error("Error logging out:", error);
    }
  };

  const hasMultipleProjects = allowedProjects.length > 1;
  const isRestricted = getAllowedProjectNames() !== null;

  return (
    <nav
      className="fixed top-0 left-0 right-0 z-50 bg-white border-b border-gray-200 shadow-sm transition-all duration-300"
      style={{
        marginLeft: sidebarOpen ? "300px" : "60px",
        width: sidebarOpen ? "calc(100% - 300px)" : "calc(100% - 60px)",
      }}
    >
      <div className="flex items-center justify-between h-16 px-6">
        {/* Logo */}
        <div className="flex-shrink-0">
          <img src={Logo} alt="Logo" className="h-10 w-auto" />
        </div>

        {/* Project Selector */}
        <div className="flex-1 max-w-md mx-8">
          {allowedProjects.length === 0 ? (
            <div className="w-full px-4 py-2 text-sm text-gray-500 bg-gray-50 border border-gray-300 rounded-lg">
              No projects assigned
            </div>
          ) : (
            <select
              value={selectedProject}
              onChange={handleProjectChange}
              disabled={!hasMultipleProjects} // Disable if only 1 project
              className={`
                w-full px-4 py-2 text-sm font-medium text-gray-700 bg-white border rounded-lg shadow-sm
                focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500
                ${!hasMultipleProjects 
                  ? 'border-gray-300 bg-gray-50 cursor-not-allowed' 
                  : 'border-gray-300 hover:border-gray-400'}
              `}
              title={!hasMultipleProjects ? "Access restricted to this project" : ""}
            >
              <option value="">Select Project</option>
              {allowedProjects.map((project) => (
                <option key={project.id} value={project.name}>
                  {project.name}
                </option>
              ))}
            </select>
          )}
        </div>

        {/* Profile */}
        <div className="relative">
          <button
            id="profile-dropdown"
            onClick={toggleProfileDropdown}
            className="flex items-center space-x-3 text-gray-700 hover:text-gray-900 focus:outline-none transition"
          >
            <div className="w-10 h-10 rounded-full bg-gradient-to-r from-gray-500 to-gray-600 flex items-center justify-center text-white font-semibold text-sm">
              {username?.[0]?.toUpperCase() || "U"}
            </div>
            <span className="hidden md:block text-sm font-medium">
              {sessionStorage.getItem("username")}
            </span>
            <svg
              className={`w-4 h-4 transition-transform ${profileDropdownOpen ? "rotate-180" : ""}`}
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
            </svg>
          </button>

          {profileDropdownOpen && (
            <div
              id="profile-dropdown-menu"
              className="absolute right-0 mt-2 w-56 bg-white rounded-lg shadow-lg border border-gray-200 py-2 z-10"
            >
              <div className="px-4 py-3 border-b border-gray-100">
                <p className="text-sm font-semibold text-gray-900">
                  {sessionStorage.getItem("username")}
                </p>
                <p className="text-xs text-gray-500">User Account</p>
              </div>
              <button
                onClick={handleLogout}
                className="w-full px-4 py-2 text-left text-sm text-red-600 hover:bg-red-50 transition"
              >
                Logout
              </button>
            </div>
          )}
        </div>
      </div>
    </nav>
  );
};

export default Navbar;